
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'

import loadPage from '../../components/loadingPage'
import global from '../../../static/js/global'
import $ from 'jquery'
export default {
data (){
return {
value1:'装修垃圾清运费',
value2:'5元/本',
value3:'0',
changeValue:'0',
numMoney:'',
value4:'拆墙费',
value5:'50元/㎡',
am_mbg1:false,
show_1:false,
value6:'',
value7:'',
mValue5:'90.97㎡',
mValue6:'273.0元',
mValue7:'装修许可证工本费',
mValue8:'5元/本',
mValue9:'',
mValue10:'0',
list:[],

houselist:[[],[],[]],
houselistid:[],
house:[' ',' ',' '],
buildid:[],
hsNo:'',
hsName:'',
messageWarn:'',
username:'',
houseBind:'',
alertTitle:'',
alertContent:'',
showAlert:false,
allbuild:'',
comnCode:'',
mTitles:'',
bShow:false,
mContent:'',
yjMoney:'',
ym1:'',
ym2:'',
billCode:'',
areaNum:'',
staCode:'',
showTip:''
}
},
directives: {
TransferDom
},
components:{
Flexbox,
FlexboxItem,
XInput,
XNumber,
XButton,
PopupPicker,
loadPage,
Alert,
Confirm,
$
},
beforeMount(){
if(this.$router.history.current.path == "/relatedToNumber"){
document.title = "装修费用";
}
this.hsName =this.$router.history.current.query.hsName;
this.hsNos = this.$router.history.current.query.hsNo;
if(this.hsNos==null){
this.showTip = '请选择房号';
}
this.house[2] = this.hsNos;

if(this.hsNos == "" || this.hsNos == null){
this.list = [];
}else{
this.firstLoad(this.hsNos);
}
},
mounted(){
this.comnCode = this.$router.history.current.query.comnCode;
},

watch:{
list:function(){
this.sumTotalMoney();
}
},
methods:{
firstLoad(hsNo){
this.hsNo = hsNo;
this.showTip ='';
this.list = [];
if(!this.hsName.trim()) {
this.showTip = '请输入业主姓名';
return;
}

this.show_1 = true;
let usIn = new Object();
usIn.comnCode = this.$router.history.current.query.comnCode;
usIn.openId = this.$router.history.current.query.openId;
usIn.feeCode = this.$router.history.current.query.feeCode;
usIn.hsNo = hsNo;
usIn.hsname =  this.hsName;
usIn.mainPhone = this.$router.history.current.query.mainPhone;
usIn.configId = this.$router.history.current.query.configId;
let url = global.host + 'temporaryCharge/initDecorate';
this.$http.post(url,usIn).then(function(res){

let msList = res.body.result;
if(res.body.success){
for(let i in msList){
this.list.push(msList[i]);
}
this.sumTotalMoney();
}else if(!res.body.success){



this.showTip = res.body.message;
}
this.staCode = res.body.statusCode;
this.show_1 = false;
},function(err){
console.log(err)
})
},
onConfirm(){//业主未绑定选完房号确定回填初始房号

this.house = [];
this.house[2] = this.hsNos;
if(this.staCode == '120'){
this.$router.push({path:'/houseBind',query:{openid:this.$router.history.current.query.openId,phone:this.$router.history.current.query.mainPhone,IsDefault:0}})
}
},
cancl(){
this.house = [];
this.house[2] = this.hsNos;
if(this.staCode == '120'){
this.$router.push({path:'/feePayment',query:{openid:this.$router.history.current.query.openId,comnCode:this.$router.history.current.query.comnCode}})
}
},
sumTotalMoney(){//总价计算
let this_ = this;
setTimeout(function(){
let sumTotalMoney = 0;
for(var i=0;i<this_.list.length;i++){
var obj = this_.list[i];

if(obj.isChargeD == null ||  obj.isChargeD == "0"){
$(".am_sclor_"+obj.feeCode).hide();
$(".am_mbg_"+obj.feeCode).css("background","none");
sumTotalMoney += Number($("#"+obj.feeCode+"_feeMoney").val());
}else{
$(".am_sclor_"+obj.feeCode).show();
$(".am_mbg_"+obj.feeCode).css("background","#d9d9d9b0");
}
}
this_.numMoney = sumTotalMoney.toFixed(2);
}, 200);

/*if($("#pds").html() == '1'){
$(".am_sclor").show();
this.am_mbg1 = true;
}else if($("#pds").html() == '0'){
$(".am_sclor").hide();
this.am_mbg1 = false;
}
if(this.am_mbg1 == true){
let talNums = Number(this.value3) + Number(this.mValue10);
this.numMoney = talNums.toFixed(2);
}else{
let talNums = Number($("#s1").text()) + Number($("#s2").text())+ Number(this.value3) + Number(this.mValue10)
this.numMoney = talNums.toFixed(2);
}*/
},
payFord(){//支付
if(Number(this.numMoney)<=0){
this.showAlert = true;
this.alertTitle = '温馨提示';
this.alertContent = '金额不能为零！';
return;
}
let list = new Array();
for(var i=0;i<this.list.length;i++){
var obj = this.list[i];
list[i] = new Object();

if(obj.calType =="0"){

if(obj.isChargeD == null ||  obj.isChargeD == "0"){
list[i].feeCode = obj.feeCode;
list[i].feeMoney = $("#"+obj.feeCode+"_feeMoney").val();
list[i].calType = obj.calType;
list[i].calArea = obj.calArea;
}
}
if(obj.calType =="1"){
list[i].feeCode = obj.feeCode;
list[i].feeMoney = $("#"+obj.feeCode+"_feeMoney").val();
list[i].feeNum = this.changeValue;
list[i].calType = obj.calType;
}
if(obj.calType =="2"){
list[i].feeCode = obj.feeCode;
list[i].feeMoney = $("#"+obj.feeCode+"_feeMoney").val();
list[i].calArea = $("#"+obj.feeCode+"_calArea").val();
list[i].calType = obj.calType;
}
}

let newInfo = new Object();
newInfo.hsNo = this.hsNo;
newInfo.hsName = this.hsName;
newInfo.comnCode = this.comnCode;
newInfo.remark = '';
newInfo.sumFeeMoney = this.numMoney;
newInfo.objectData = list;

let Url = global.host + 'temporaryCharge/collectDecorate';
this.$http.post(Url,newInfo).then(function(res){
if(res.body.success == true){
this.billCode =res.body.result;
this.goPay();
}

},function(err){
console.log(err)
})

},
changeNum(){
this.value3 = this.changeValue * parseInt(this.value2);
this.sumTotalMoney();
},
goPay(){
let senddata = new Object();
senddata.comnCode = this.comnCode;
senddata.memberNo = this.$router.history.current.query.mainPhone;
senddata.openid = this.$router.history.current.query.openId;
senddata.tradeAmount = this.numMoney;
senddata.tradeNo = this.billCode;
senddata.tradeName='临时收费';
senddata.tradeDesc='装修费用';
let url = global.host + 'temporaryCharge/getpayurl'
this.$http.post(url,senddata).then(function(res){
if(res.body.code == '110'){
window.location.href = res.body.payurl;
}else{
this.prompt = '支付异常,请稍候再试'
this.submitable = false;
this.showprompt = true;
}

},function(err){
console.log(err)
})
},
changeMoney(){//拆墙费输入计算
this.mValue9 = Number($("#nVal").find("input").val());
this.mValue10 = this.mValue9 * Number($("#mflv").find("strong").find("b").html());
this.sumTotalMoney();
},
onHides(hsNunber){
this.list = [];
this.firstLoad(hsNunber);

},
/*房间绑定验证*/
bindHouse(){
this.hsName = this.hsName.replace(/(^\s*)|(\s*$)/g,"");
this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode='+ this.comnCode + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0],this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' +  this.house[2] + '&userName=' + encodeURIComponent(this.hsName),).then(function(res){
if(res.body.success){
/*改变样式 存在*/
this.houseBind = true;
this.bindHouseSubmit();
}else{
/*改变样式 不存在*/
/*this.alertTitle ='温馨提示'
this.alertContent = '请输入物业登记的业主姓名'
this.showAlert = true;*/
this.houseBind = false;
}
},function(err){
console.log(err);
})
},
/*房间检测*/
updateVal(){
this.houseBind = false;
},

checkBind(){
this.hsName = this.hsName.replace(/(^\s*)|(\s*$)/g,"");
if(!this.hsNo){
this.showTip = '请选择房间';
}else if(!this.hsName) {
this.showTip = '请输入业主姓名';
}else{
this.firstLoad(this.hsNo);
}
/*this.houseBind = false;
if(!this.house[0] && !this.house[1] && !this.house[2]){
this.showTip = '请选择房间';
}else if(!this.hsName){
this.showTip = '请输入业主姓名';
}else{
this.hsName = this.hsName.replace(/(^\s*)|(\s*$)/g,"");
this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode='+ this.comnCode + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0],this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' +  this.house[2] + '&userName=' + encodeURIComponent(this.hsName),).then(function(res){
if(res.body.success){
/!*改变样式 存在*!/
this.houseBind = true;
}else{
/!*改变样式 不存在*!/
this.showTip = '';
this.houseBind = false;
}
},function(err){
console.log(err);
})
}*/
},
/*选择小区*/
selectDistrict(){
this.houselist = [];
this.buildid = [];
this.houselistid = [];

/*获取小区中的楼号信息*/
this.$http.get(global.host + 'building/getList?comnCode='+ this.comnCode).then(function(resbuild){
if(resbuild.body.result){
let arr1 = [];
let databuild = resbuild.body.result
this.allbuild =  resbuild.body.result;
for(let j = 0 ;j < databuild.length ; j++){
arr1.push(databuild[j].buildName + (databuild[j].unitName ? databuild[j].unitName : ''))
if(databuild[j].unitid){
this.houselistid.push(databuild[j].buildid)
this.buildid.push(databuild[j].unitid)
}else{
this.houselistid.push(databuild[j].buildid)
}
}
this.houselist.push(arr1);
let arr2 = [];
for(let i = 0 ;i < databuild[0].height.length; i++){
arr2.push(databuild[0].height[i])
}
this.houselist.push(arr2)
/*获取房间的信息*/
this.$http.get(global.host + 'house/getList?comnCode='+ this.comnCode + '&buildCode=' + this.houselistid[0] + '&fool=1F' + '&unit=' + (this.buildid[0] ? this.buildid[0] :'')).then(function(reshouse){
if(reshouse.body.result){
let datahouse = reshouse.body.result;
let arr3 = [];
for(let k= 0 ;k < datahouse.length ; k++){
arr3.push(datahouse[k].hsNo)
}
this.houselist.push(arr3)
}
},function(errhouse){
console.log(errhouse)
})
}
},function(errbuild){
console.log(errbuild)
})
},
/*联调函数*/
selectValue(value){

for(let i = 0 ; i < 3 ; i++){
if(value[i] != this.house[i]){
switch(i){
case 0:
this.house[0] = value[0];
this.getStoreyInfo(value[0]);
this.$nextTick(() => {
PopupPicker.props.data = this.houselist
})
return;
case 1:
this.house[0] = value[0];
this.house[1] = value[1];
this.getHouseInfo(value[0],value[1]);
this.$nextTick(() => {
PopupPicker.props.data = this.houselist
})
return;
case 2:
this.house[0] = value[0];
this.house[1] = value[1];
this.house[2] = value[2];
return;
}
}
}
},
/*选择楼号获取楼层高度*/
getStoreyInfo(storeyname){
this.$http.get(global.host + 'building/getList?comnCode='+ this.comnCode).then(function(res){
let storeyid = this.getIndex(this.houselist[0],storeyname);
let commid = this.comnCode;
if(res.body.result) {
let size = this.houselist[1].length;
for (var j = 1; j < size; j++) {
this.houselist[1].pop();
}
let size1 = this.houselist[2].length;
for (var j = 1; j < size1; j++) {
this.houselist[2].pop();
}
let databuild = res.body.result[this.getIndex(this.houselist[0],storeyname)].height;
for (let i = 0; i < databuild.length; i++) {
this.houselist[1].push(databuild[i])
}
if(this.houselist[1].length > 1){
this.houselist[1].shift();
}else{
this.houselist[1].push(' ');
this.houselist[1].shift();
}
this.$http.get(global.host + 'house/getList?comnCode=' + this.comnCode + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + (this.house[1] ? this.house[1] : 1) + '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] : ''),).then(function (res) {
if (res.body.result) {
let data = res.body.result;
let mis = [];
let size = this.houselist[2].length;
for(let a = 1; a< size; a++){
this.houselist[2].pop();
}
for (let k = 0; k < data.length; k++) {
this.houselist[2].push(data[k].hsNo)
}
if(this.houselist[2].length > 1){
this.houselist[2].shift();
}

} else {
this.houselist[2].push('')
let houseNum = this.houselist[2].length - 1;
for (let i = 0; i < houseNum; i++) {
this.houselist[2].pop()
}
}

}, function (err) {
console.log(err)
})
}
},function(err){
console.log(err)
});
},
/*选择楼层高度获取房间号*/
getHouseInfo(storeyname,floor){
let storeyid = this.getIndex(this.houselist[0],storeyname);
let commid = this.comnCode;
let houseInfo = new Array();
this.$http.get(global.host + 'house/getList?comnCode='+ this.comnCode + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + floor+ '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] :'') ,).then(function(res){
console.log(res)
if(res.body.result){
let size = this.houselist[2].length;
for(var j = 1 ; j < size ; j++){
this.houselist[2].pop();
}
let data = res.body.result;
for(let k= 0 ;k < data.length ; k++){
this.houselist[2].push(data[k].hsNo)
}
this.houselist[2].shift();
}else{
/*清空房间信息 追加一个空的信息 防止数据为空*/
let size = this.houselist[2].length;
for(var j = 1 ; j < size ; j++){
this.houselist[2].pop();
}
this.houselist[2].push('')
this.houselist[2].shift()
}
},function(err){
console.log(err)
})
},
/*获取索引值*/
getIndex(arr,feild){
for(let i = 0 ; i < arr.length; i++){
if(feild == arr[i]){
return i;
}else{
continue
}
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/temporaryCharge/decorationCost.vue